import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Styled from "../../../CompanyForm.styled";
import { sendEmailAndSecurityCode } from "../../../config/fetchAPI";
import { emailValid } from "../../../config/validation";
import { ButtonPurple } from "../../elements/Buttons/Buttons.js";
import CustomAlert from "../../elements/Alert/Alert";
import { CustomTextField } from "../../elements/TextField/TextField";
import logo from "../../../images/horizontal-logo.png";

export const EntryPage = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState("");
    const [error, setError] = useState("");
    const [isValid, setIsValid] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const uuidFromQuery = queryParams.get("uuid");

        const link = window.location.href;
        // storing full url in sessionstorage to be used in continue later textfield
        sessionStorage.setItem("fullUrl", link);

        if (uuidFromQuery) {
            if (sessionStorage.getItem("storedUUID") !== uuidFromQuery) {
                sessionStorage.removeItem("authToken");
            }
            sessionStorage.setItem("storedUUID", uuidFromQuery);
        } else {
            const storedUUID = sessionStorage.getItem(
                "storedUUID",
                uuidFromQuery
            );
            if (!storedUUID) {
                window.location.href = "http://www.nla.com.au/";
            }
        }
    }, [location.search]);

    const handleEmailChange = (event) => {
        const email = event.target.value;
        setEmail(email);

        const isEmailValid = emailValid(email);
        setIsValid(isEmailValid);

        if (!isEmailValid) {
            setEmailErrorMsg("Please enter a valid email address");
        } else {
            setEmailErrorMsg("");
        }
    };
    const validateForm = () => {
        let valid = true;

        // Validate Company Name
        if (!email) {
            setEmailErrorMsg("Email is required.");
            valid = false;
        }

        return valid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        setLoading(true);
        setEmailErrorMsg("");

        await sendEmail(email);

        setLoading(false);
    };
    const sendEmail = async (email) => {
        try {
            const result = await sendEmailAndSecurityCode(email);

            // If the otp request is valid, navigate to the verification page
            if (
                result &&
                result.message &&
                result.message.includes("OTP Sent")
            ) {
                sessionStorage.setItem("email", email);
                navigate("/verification");
                return;
            }

            if (result && result === "error_400") {
                setError(
                    "Please verify if your email and the url uuid are correct or contact support."
                );
                return;
            }

            if (result && result === "error_401") {
                setError("Unauthorized access. Please contact support.");
                return;
            }

            if (result && result === "error_404") {
                setError("Not found. Please contact support.");
                return;
            }

            if (result && result === "error_500") {
                setError("Internal server error. Please contact support.");
                return;
            }
        } catch (error) {
            // Let default error handle the error.
            setError("An unexpected error occurred. Please try again.");
        }
    };

    const handleAlertClose = () => {
        setError(""); // Reset the error when alert is closed
    };

    return (
        <Styled.EntryContainer>
            <Styled.EntryBox>
                <Styled.LogoContainer>
                    <Styled.CustomLogo
                        src={logo}
                        alt="Logo"
                    />
                </Styled.LogoContainer>

                <Styled.EntryNoteBox>
                    <Styled.SubTitle>
                        Thank you for choosing Novated Lease Australia!
                    </Styled.SubTitle>
                    <Styled.BodyText>
                        To get started, we need a few details about your
                        company.
                    </Styled.BodyText>
                    <Styled.BodyText>
                        This information helps us tailor our services to your
                        needs and ensures a seamless experience for you and your
                        employees.
                    </Styled.BodyText>
                    <Styled.BodyText>
                        Please take a moment to complete the form below.
                    </Styled.BodyText>
                    <Styled.BodyText>
                        Our team will review your submission and guide you
                        through the onboarding process. If you have any
                        questions, feel free to reach out to our support team at{" "}
                        <Styled.StyledLink href="mailto:employersupport@nla.com.au">
                            employersupport@nla.com.au
                        </Styled.StyledLink>
                        .
                    </Styled.BodyText>
                    <Styled.BodyText
                        style={{
                            fontSize: "20px",
                            fontWeight: "500",
                            fontStyle: "italic",
                        }}>
                        We're excited to partner with you!
                    </Styled.BodyText>
                </Styled.EntryNoteBox>

                <Styled.MainTitle style={{ margin: "40px 0 0 0" }}>
                    To begin, please enter your work email address.
                </Styled.MainTitle>

                <Styled.EntryCardBox>
                    <CustomTextField
                        label="Enter your work email"
                        variant="outlined"
                        value={email}
                        type="email"
                        onChange={handleEmailChange}
                        error={emailErrorMsg !== ""}
                        helperText={emailErrorMsg}
                    />

                    <ButtonPurple
                        onClick={handleSubmit}
                        disabled={loading || !isValid || !email}>
                        {loading ? "Sending.." : "Send security code"}
                    </ButtonPurple>
                </Styled.EntryCardBox>

                <Styled.ErrorMessageWrapper>
                    {error && (
                        <CustomAlert
                            message={error}
                            onClose={handleAlertClose}
                        />
                    )}
                </Styled.ErrorMessageWrapper>
            </Styled.EntryBox>
        </Styled.EntryContainer>
    );
};
